import { render, staticRenderFns } from "./MotorQuoteRefPremium.vue?vue&type=template&id=505ae8d6&"
import script from "./MotorQuoteRefPremium.vue?vue&type=script&lang=js&"
export * from "./MotorQuoteRefPremium.vue?vue&type=script&lang=js&"
import style0 from "./MotorQuoteRefPremium.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorQuoteRefPremium.vue"
export default component.exports